// extracted by mini-css-extract-plugin
export var checkboxInputRow = "v_sF";
export var checkboxInputColumn = "v_sG";
export var inputOptionRow = "v_r5";
export var inputOptionColumn = "v_r6";